import React from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

import { useProjectCardOwnerStyles } from './project-card-owner.styles'
import Skeleton from '@material-ui/lab/Skeleton'

export const ProjectCardOwnerSkeleton = () => {
  const classes = useProjectCardOwnerStyles()

  return (
    <Card square elevation={0} className={classes.root}>
      <CardContent className={classes.content}>
        <Skeleton variant="rect" className={classes.img} />
        <div className={classes.projectWrap}>
          <Skeleton className={classes.projectName} />
          <div className={classes.projectDescription}>
            <Skeleton width={80} className={classes.categoryName} />
            <Skeleton width={80} className={classes.cost} />
            <Skeleton width={100} className={classes.publishStatus} />
          </div>
          <div className={classes.iconWrap}>
            <div className={classes.icon}>
              <Skeleton width={24} height={24} style={{ marginRight: 16 }} />
            </div>
            <div className={classes.icon}>
              <Skeleton width={24} height={24} />
            </div>
          </div>
        </div>
        <div className={classes.buttonWrap}>
          <Skeleton width={100} height={50} style={{ marginRight: 16 }} />
          <Skeleton width={30} className={classes.menu} />
        </div>
      </CardContent>
    </Card>
  )
}
